import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { api } from '../api/client';
export default function MediaGcDialog({ onClose, onChanged }) {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState('load');
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);
    async function loadDryRun() {
        setBusy('load');
        setError(null);
        try {
            const r = await api.mediaGc(true);
            setData({ orphans: r.orphans, files_removed: 0 });
        }
        catch (e) {
            setError(e?.message ?? 'Failed');
        }
        finally {
            setBusy(null);
        }
    }
    async function apply() {
        if (!data)
            return;
        if (!window.confirm(`Permanently delete ${data.orphans.length} unreferenced media file(s) and their variants?`))
            return;
        setBusy('apply');
        setError(null);
        try {
            const r = await api.mediaGc(false);
            setData({ orphans: [], files_removed: r.files_removed });
            setDone(true);
            onChanged();
        }
        catch (e) {
            setError(e?.message ?? 'Failed');
        }
        finally {
            setBusy(null);
        }
    }
    useEffect(() => { loadDryRun(); }, []);
    useEffect(() => {
        function onKey(e) { if (e.key === 'Escape' && !busy)
            onClose(); }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [busy, onClose]);
    return (_jsx("div", { className: "modal-backdrop", onClick: (e) => { if (e.target === e.currentTarget && !busy)
            onClose(); }, children: _jsxs("div", { className: "modal small-modal", children: [_jsxs("div", { className: "modal-head", children: [_jsx("div", { className: "modal-title", children: "Clean unused media" }), _jsx("button", { className: "ghost", onClick: onClose, disabled: busy !== null, children: "Close" })] }), _jsxs("div", { className: "modal-body padded scroll", children: [busy === 'load' && _jsx("div", { className: "muted", children: "Scanning\u2026" }), error && _jsx("div", { className: "err small", children: error }), data && !done && data.orphans.length === 0 && (_jsx("div", { className: "ok small", children: "No unused media. Everything is referenced somewhere." })), data && !done && data.orphans.length > 0 && (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["Found ", _jsx("strong", { children: data.orphans.length }), " file(s) not referenced by any page or content HTML."] }), _jsx("ul", { className: "orphan-list", children: data.orphans.slice(0, 50).map((o) => (_jsxs("li", { children: [_jsx("span", { className: "muted small", children: o.kind }), _jsx("code", { children: o.rel }), _jsxs("span", { className: "muted small", children: [prettyBytes(o.bytes), o.variants ? ` · ${o.variants} variants` : ''] })] }, o.rel))) }), data.orphans.length > 50 && _jsxs("p", { className: "muted small", children: ["\u2026and ", data.orphans.length - 50, " more."] })] })), done && _jsxs("div", { className: "ok", children: ["Removed ", data?.files_removed ?? 0, " files."] })] }), _jsxs("div", { className: "modal-foot", children: [_jsx("span", { className: "muted small", children: "Originals + variants are deleted from disk. This cannot be undone." }), _jsxs("div", { className: "actions", children: [!done && data && data.orphans.length > 0 && (_jsx("button", { className: "ghost", onClick: apply, disabled: busy !== null, children: busy === 'apply' ? 'Cleaning…' : `Delete ${data.orphans.length} file(s)` })), _jsx("button", { onClick: onClose, children: done ? 'Close' : 'Cancel' })] })] })] }) }));
}
function prettyBytes(n) {
    if (n < 1024)
        return n + 'B';
    if (n < 1024 * 1024)
        return (n / 1024).toFixed(0) + 'KB';
    return (n / 1024 / 1024).toFixed(1) + 'MB';
}
